import { Line, mixins } from 'vue-chartjs';
import { Loading } from 'element-ui';
import api from '@/api';
import * as ChartColors from '@/util/chartColors';
import ReportData from '@/mixin/ReportData';

const { reactiveData } = mixins;

export default {
  name: 'NewVsReturningChart',
  extends: Line,
  mixins: [reactiveData, ReportData],
  props: {
    priorYear: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: true,
          text: 'New vs. Returning Clients',
        },
        scales: {
          xAxes: [
            {
              type: 'time',
              time: {
                minUnit: 'day',
              },
            },
          ],
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      },
    };
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
    this.fetchData();
  },
  methods: {
    fetchData() {
      const loadingInstance = Loading.service({
        target: this.$el,
      });
      api.report.getNewVsReturningReport(this.dateRange, this.forOffice, this.priorYear).then((result) => {
        this.buildDataset(result.data);
      }).finally(() => {
        this.$nextTick(() => {
          loadingInstance.close();
        });
      });
    },
    buildDataset(results) {
      this.chartData = {
        datasets: [
          {
            label: 'Total',
            ...ChartColors.getLineDatasetColorProps(ChartColors.BLUE),
            data: results.total,
            spanGaps: true,
          },
          {
            label: 'New',
            ...ChartColors.getLineDatasetColorProps(ChartColors.GREEN),
            data: results.new,
            spanGaps: true,
          },
          {
            label: 'Returning',
            ...ChartColors.getLineDatasetColorProps(ChartColors.ORANGE),
            data: results.returning,
            spanGaps: true,
          },
        ],
      };
    },
  },
};
